<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <!--BC编号-->
                <el-form-item :label="$t('BC.BCNumber')" prop="serialNo">
                  <el-input v-model.trim="queryCondition.serialNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('BC.SSRNumber')" prop="ssrNo">
                  <!--SSR编号-->
                  <el-input v-model.trim="queryCondition.ssrNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('BC.RFPNumber')" prop="rfpNo">
                  <!--RFP编号-->
                  <el-input v-model.trim="queryCondition.rfpNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('BC.createBy')" prop="creator">
                  <!--创建人-->
                  <el-input v-model.trim="queryCondition.creator" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('BC.Category1')" prop="category1Id">
                    <el-select v-model="queryCondition.category1Id" clearable @change="changeCategory1()" :placeholder="$t('BC.sel')" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('BC.Category2')" prop="category2Id">
                    <el-select v-model="queryCondition.category2Id" clearable :placeholder="$t('BC.sel')" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Create Date(From)" prop="beginDate">
                    <el-date-picker v-model="queryCondition.beginDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart" :placeholder="$t('BC.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Create Date(To)" prop="endDate">
                    <el-date-picker v-model="queryCondition.endDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd" :placeholder="$t('BC.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('BC.status')" prop="status">
                    <ic-select clearable table="TT_BC" field="STATUS" v-model="queryCondition.status" :placeholder="$t('BC.sel')" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('BC.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm()" type="primary">{{$t('BC.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" @click="addBC()" v-acl="SaveBc">{{$t('BC.newBuilt')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="RecallBc" @click="withdraw">Revoke</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420' @selection-change="handleSelectChange">
      <el-table-column align="center" type="selection" width="50" />
      <el-table-column show-overflow-tooltip prop="serialNo" :label="$t('BC.BCNumber')">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{scope.row.serialNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="ssrNo" :label="$t('BC.SSRNumber')"></el-table-column><!-- SSR编号 -->
      <el-table-column show-overflow-tooltip prop="rfpNo" :label="$t('BC.RFPNumber')"></el-table-column><!-- RFP编号 -->
      <el-table-column show-overflow-tooltip prop="creator" :label="$t('BC.createBy')"></el-table-column><!-- 创建人 -->
      <el-table-column show-overflow-tooltip prop="projectName" :label="$t('BC.projectName')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="categoryOneName" :label="$t('BC.Category1')"></el-table-column><!-- Category1 -->
      <el-table-column show-overflow-tooltip prop="categoryTwoName" :label="$t('BC.Category2')"></el-table-column><!-- Category2 -->
      <el-table-column show-overflow-tooltip prop="status" :label="$t('BC.status')">
        <template slot-scope="scope">{{scope.row.status|ic("TT_BC","STATUS")}}</template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>

  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import BCApi from "@/api/BC/BC";
import { apiService } from "@/api/material/material-master-data";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      selectRow: [],
      dataArr: [],
      queryCondition: {
        serialNo: '',
        creator: '',
        beginDate: '',
        endDate: '',
        status: '',
        ssrNo: '',
        rfpNo: '',
        category2Id: '',
        category1Id: '',
        pageNum: 1,
        pageSize: 15,
      },
      tableList: [],
      categoryList1: [],
      categoryList2: [],
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.beginDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },

    };
  },
  created() {

    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    }
    // else {
    //     let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    //     for (let i = 0, len = permission.length; i < len; i++) {
    //         if (permission[i] == 'IS_MDM') {
    //             this.emplFlag = 'MDM';
    //         }
    //     }
    // }
    this.queryData();
    this.getCategoryList()
  },
  methods: {
    // 回撤
    withdraw() {
      let that = this;
      if (that.selectRow.length == 0) {
        this.$message.error(this.$t('BC.pleaseChooseToWithdraw'))
        return false;
      }
      let rows = that.selectRow;
      let checkData = false;
      for (let index in rows) {
        let rowData = rows[index];
        // draft: 草稿 appr_pass： 通过
        if (['draft', 'appr_pass', 'appr_back'].indexOf(rowData.status) >= 0) {
          checkData = true;
        }
      }
      if (checkData) {
        this.$message.error(this.$t('BC.checkWithdraw'))
        return false;
      } else {
        that.$confirm(that.$t('BC.sureWithdraw'), 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          let ttBcIdArr = rows.map(row => row.ttBcId);
          // 每次只能撤回一条
          if (rows.length && rows.length > 1) {
            this.$message.error(this.$t('BC.withdrawOnly'))
            return false
          }
          let ttBcId = ttBcIdArr.join()
          BCApi.recall(ttBcId).then((res) => {
            if (res.code == '200') {
              this.queryData();
              this.selectRow = [];
            } else {
              this.$message.error(this.$t(res.msg) || 'Operate error')
            }
          });
        })
      }
    },
    //选择操作
    handleSelectChange: function (row) {
      this.selectRow = row;
    },
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (this.emplFlag == 'SUP') {
        this.queryCondition.tmSupplierId = JSON.parse(localStorage.getItem("supplierObj")).tmSupplierId
      }
      BCApi.getList(this.queryCondition).then(res => {
        that.tableList = res.data.records;
        that.totalCount = res.data.total;
      });
    },
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        serialNo: '',
        creator: '',
        beginDate: '',
        endDate: '',
        status: '',
        ssrNo: '',
        rfpNo: '',
        category2Id: '',
        category1Id: '',
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    toDetail(row) {
      this.$router.push({
        path: `/BCDetail`,
        query: { ttBcId: row.ttBcId }
      });
    },
    addBC() {
      this.$router.push({
        path: `/BCDetail`,
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
        console.log(res.data, 'categoryList1')
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.category2Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.category1Id }).then((res) => {
        this.categoryList2 = res.data;
        console.log(res.data, 'categoryList2')
      });
    },
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.BCList .createDateArr .el-form-item__content {
  display: flex;
}
</style>
